<div class="dialog-root">
  <div class="dialog-header">
    <div class="title">
      <mat-icon>attach_file</mat-icon>
      <span class="file-name">{{ data.fileName }}</span>
    </div>
    <div class="actions">
      <button mat-icon-button (click)="download()" title="Abrir en nueva pestaña">
        <mat-icon>open_in_new</mat-icon>
      </button>
      <button mat-icon-button (click)="close()" title="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog-body">
    <ng-container [ngSwitch]="kind">
      <img *ngSwitchCase="'image'" [src]="data.url" [alt]="data.fileName" />

      <video *ngSwitchCase="'video'" controls [src]="data.url" preload="metadata">
        Tu navegador no soporta video.
      </video>

      <audio *ngSwitchCase="'audio'" controls [src]="data.url">
        Tu navegador no soporta audio.
      </audio>

      <iframe *ngSwitchCase="'pdf'" [src]="safeUrl" frameborder="0"></iframe>

      <div *ngSwitchCase="'other'" class="unsupported">
        <mat-icon>description</mat-icon>
        <p>Este tipo de archivo no se puede previsualizar en el navegador.</p>
        <button class="download-btn" (click)="download()">
          <mat-icon>download</mat-icon>
          Descargar
        </button>
      </div>
    </ng-container>
  </div>
</div>
